<div class="card">
  <!-- Grid and Kanban pin the stats row + filters and scroll only the content
       below; the table view keeps p-table's own scrolling. -->
  <div class="card-content"
       [class.card-content--fixed-header]="viewMode === 'grid' || viewMode === 'kanban'">

    <!-- ============ Stats cards ============ -->
    <div class="stats-cards-row stats-cards-row--nowrap" *ngIf="!loading">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value" *ngIf="hasRates">
            <span class="cur">≈ USD</span> {{ formatMoney(usdPipeline) }}
          </span>
          <span class="stats-card-value" *ngIf="!hasRates">—</span>
          <span class="stats-card-label">Active Pipeline</span>
          <span class="stats-card-sublabel">
            {{ openDealCount }} open {{ openDealCount === 1 ? 'deal' : 'deals' }} (excl. Won / Lost)
            <ng-container *ngIf="unratedDealCount > 0"> · {{ unratedDealCount }} unrated excluded</ng-container>
          </span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>

      <div class="stats-card stats-card--info">
        <div class="stats-card-main">
          <span class="stats-card-value" *ngIf="hasRates">
            <span class="cur">≈ USD</span> {{ formatMoney(usdWeighted) }}
          </span>
          <span class="stats-card-value" *ngIf="!hasRates">—</span>
          <span class="stats-card-label">Weighted Value</span>
          <span class="stats-card-sublabel">Revenue × Winning % · {{ openDealCount }} open</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-chart-bar"></i></div>
      </div>

      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value" *ngIf="hasRates">
            <span class="cur">≈ USD</span> {{ formatMoney(usdAvgDealSize) }}
          </span>
          <span class="stats-card-value" *ngIf="!hasRates">—</span>
          <span class="stats-card-label">Avg Deal Size</span>
          <span class="stats-card-sublabel">
            Across {{ ratedDealCount }} open {{ ratedDealCount === 1 ? 'deal' : 'deals' }}
          </span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-dollar"></i></div>
      </div>

      <div class="stats-card stats-card--info">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ closingThisMonthCount }}</span>
          <span class="stats-card-label">Closing This Month</span>
          <span class="stats-card-sublabel">By expected close date</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-calendar"></i></div>
      </div>

      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ winRatePct }}%</span>
          <span class="stats-card-label">Win Rate</span>
          <span class="stats-card-sublabel">{{ wonCount }} won of {{ wonCount + lostCount }} closed</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-percentage"></i></div>
      </div>
    </div>

    <!-- ============ Collapsible filter bar (driven by header filter icon) ============ -->
    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible"
         *ngIf="!loading">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label">Status</label>
          <p-select [(ngModel)]="selectedProjectStatus" (ngModelChange)="applyFilters()"
            [options]="projectStatusOptions" optionLabel="label" optionValue="value"
            placeholder="All" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Stage</label>
          <p-select [(ngModel)]="selectedStage" (ngModelChange)="applyFilters()"
            [options]="stageOptions" optionLabel="label" optionValue="value"
            placeholder="All stages" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Progress</label>
          <p-select [(ngModel)]="selectedProgress" (ngModelChange)="applyFilters()"
            [options]="progressOptions" optionLabel="label" optionValue="value"
            placeholder="All progress" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Presales PM</label>
          <p-select [(ngModel)]="selectedPMId" (ngModelChange)="applyFilters()"
            [options]="pmOptions" optionLabel="name" optionValue="id"
            placeholder="All PMs" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Presales Client</label>
          <p-select [(ngModel)]="selectedClientId" (ngModelChange)="applyFilters()"
            [options]="clientOptions" optionLabel="name" optionValue="id"
            placeholder="All clients" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Sales Owner</label>
          <p-select [(ngModel)]="selectedAccountManagerId" (ngModelChange)="applyFilters()"
            [options]="accountManagerOptions" optionLabel="name" optionValue="id"
            placeholder="All sales owners" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Service Group</label>
          <p-select [(ngModel)]="selectedServiceGroupId" (ngModelChange)="applyFilters()"
            [options]="serviceGroupOptions" optionLabel="name" optionValue="id"
            placeholder="All groups" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions">
        <button type="button" *ngIf="hasActiveFilters()" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
        <!-- Three explicit view toggles rather than one cycling button, so the
             available views are discoverable and the active one is obvious. -->
        <button type="button" class="view-toggle-icon"
                [class.active]="viewMode === 'table'"
                (click)="setViewMode('table')"
                pTooltip="Table view" tooltipPosition="top">
          <i class="pi pi-list"></i>
        </button>
        <button type="button" class="view-toggle-icon"
                [class.active]="viewMode === 'grid'"
                (click)="setViewMode('grid')"
                pTooltip="Grid view" tooltipPosition="top">
          <i class="pi pi-th-large"></i>
        </button>
        <button type="button" class="view-toggle-icon"
                [class.active]="viewMode === 'kanban'"
                (click)="setViewMode('kanban')"
                pTooltip="Kanban view" tooltipPosition="top">
          <i class="pi pi-objects-column"></i>
        </button>
      </div>
    </div>

    <!-- ============ TABLE VIEW (default) ============ -->
    <p-table
      *ngIf="viewMode === 'table'"
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredProjects"
      [loading]="loading"
      [paginator]="filteredProjects.length > 15"
      [alwaysShowPaginator]="false"
      [rows]="15"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} presales projects"
      [tableStyle]="{ 'min-width': '100%' }"
      [resizableColumns]="true"
      columnResizeMode="expand"
      styleClass="p-datatable no-column-lines resize-handles-visible details-table">

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn pSortableColumn="projectCode" style="width: 80px;">Code <p-sortIcon field="projectCode" /></th>
          <th pResizableColumn pSortableColumn="name" style="width: 170px;">Project <p-sortIcon field="name" /></th>
          <th pResizableColumn pSortableColumn="presalesClientName" style="width: 160px;">Presales Client <p-sortIcon field="presalesClientName" /></th>
          <th pResizableColumn pSortableColumn="managerName" style="width: 160px;">Presales PM <p-sortIcon field="managerName" /></th>
          <th pResizableColumn pSortableColumn="accountManagerName" style="width: 170px;">Sales Owner <p-sortIcon field="accountManagerName" /></th>
          <th pResizableColumn pSortableColumn="serviceGroupName" style="width: 160px;">Service Group <p-sortIcon field="serviceGroupName" /></th>
          <th pResizableColumn pSortableColumn="salesStage" style="width: 100px;">Stage <p-sortIcon field="salesStage" /></th>
          <th pResizableColumn pSortableColumn="progress" style="width: 110px;">Progress <p-sortIcon field="progress" /></th>
          <th pResizableColumn pSortableColumn="projectStatus" style="width: 110px;">Status <p-sortIcon field="projectStatus" /></th>
          <th pResizableColumn pSortableColumn="endDate" style="width: 130px;">End Date <p-sortIcon field="endDate" /></th>
          <th pResizableColumn pSortableColumn="overdueDays" style="width: 110px;">Overdue <p-sortIcon field="overdueDays" /></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-project>
        <tr (click)="openDetails(project)"
            style="cursor: pointer;"
            [class.row-won]="project.salesStage === 'Won'"
            [class.row-inactive]="project.isActive === false">
          <td><span class="code-cell">{{ project.projectCode || '—' }}</span></td>
          <td>
            <span class="row-name" [pTooltip]="project.name" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.name }}</span>
          </td>
          <td [pTooltip]="project.presalesClientName" [tooltipDisabled]="!project.presalesClientName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.presalesClientName || '—' }}</td>
          <td [pTooltip]="project.managerName" [tooltipDisabled]="!project.managerName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.managerName || '—' }}</td>
          <td [pTooltip]="project.accountManagerName" [tooltipDisabled]="!project.accountManagerName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.accountManagerName || '—' }}</td>
          <td [pTooltip]="project.serviceGroupName" [tooltipDisabled]="!project.serviceGroupName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.serviceGroupName || '—' }}</td>
          <td>
            <p-tag [value]="project.salesStage" [severity]="stageSeverity(project.salesStage)" style="font-size: 0.7rem;" />
          </td>
          <td>
            <p-tag *ngIf="project.progress" [value]="progressLabel(project.progress)"
                   [severity]="progressSeverity(project.progress)" style="font-size: 0.7rem;" />
            <span *ngIf="!project.progress">—</span>
          </td>
          <td>
            <span class="status-badge-cell" *ngIf="project.projectStatus"
                  [ngClass]="projectStatusBadgeClass(project.projectStatus)">{{ project.projectStatus }}</span>
            <span *ngIf="!project.projectStatus">—</span>
          </td>
          <td><span class="row-mono">{{ formatDate(project.endDate) }}</span></td>
          <td>
            <span class="overdue-cell" *ngIf="project.overdueDays as d">{{ overdueLabel(d) }}</span>
            <span *ngIf="!project.overdueDays">—</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="11" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No presales projects yet</p>
              <p class="empty-description">Add projects on the Inventory page.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- ============ GRID VIEW (cards) ============ -->
    <!-- Same card anatomy as the Project List grid (shared .grid-card styles in
         styles/_card.scss): tinted RAG header, labelled body rows, footer badge. -->
    <div *ngIf="viewMode === 'grid'" class="grid-container card-scroll-region">
      <div class="grid-card" *ngFor="let p of filteredProjects"
           (click)="openDetails(p)">
        <div class="grid-card-header" [ngClass]="gridStatusClass(p.projectStatus)">
          <span class="grid-card-status-dot" [ngClass]="gridStatusClass(p.projectStatus)"
                [pTooltip]="p.projectStatus || 'No status'" tooltipPosition="top"></span>
          <div class="grid-card-title-wrap">
            <span class="grid-card-title" [pTooltip]="p.name" tooltipPosition="top">{{ p.name }}</span>
            <span class="grid-card-code">{{ p.projectCode || '—' }}</span>
          </div>
        </div>
        <div class="grid-card-body">
          <div class="grid-card-row">
            <i class="pi pi-building"></i>
            <span class="grid-card-value" [pTooltip]="p.presalesClientName || 'No client set'" tooltipPosition="top">
              {{ p.presalesClientName || 'No client set' }}
            </span>
          </div>
          <div class="grid-card-row grid-card-row--pm-am">
            <i class="pi pi-users"></i>
            <div class="grid-card-pm-am">
              <span [pTooltip]="'PM: ' + (p.managerName || '-')" tooltipPosition="top">{{ p.managerName || 'No PM' }}</span>
              <span class="grid-card-am" [pTooltip]="'Sales Owner: ' + (p.accountManagerName || '-')" tooltipPosition="top">
                {{ p.accountManagerName || 'No sales owner' }}
              </span>
            </div>
          </div>
          <div class="grid-card-row">
            <i class="pi pi-dollar"></i>
            <span class="grid-card-value money">
              <span class="cur">{{ p.currency }}</span> {{ formatMoney(p.revenueTarget) }}
              <ng-container *ngIf="p.winningPercentage"> · Win {{ p.winningPercentage }}%</ng-container>
            </span>
          </div>
          <div class="grid-card-row" *ngIf="p.overdueDays || p.expectedCloseDate">
            <i class="pi pi-calendar"></i>
            <span class="grid-card-value" [class.d-card-overdue]="p.overdueDays">
              {{ p.overdueDays ? overdueLabel(p.overdueDays) : formatDate(p.expectedCloseDate) }}
            </span>
          </div>
          <div class="grid-card-comments" *ngIf="p.comments"
               [pTooltip]="p.comments" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">
            {{ p.comments }}
          </div>
        </div>
        <div class="grid-card-footer">
          <p-tag [value]="p.salesStage" [severity]="stageSeverity(p.salesStage)" style="font-size: 0.65rem;" />
          <p-tag *ngIf="p.progress" [value]="progressLabel(p.progress)"
                 [severity]="progressSeverity(p.progress)" style="font-size: 0.65rem;" />
        </div>
      </div>
      <div class="empty-state" *ngIf="filteredProjects.length === 0" style="grid-column: 1 / -1;">
        <div class="empty-icon"><i class="pi pi-inbox"></i></div>
        <p class="empty-message">No presales projects yet</p>
        <p class="empty-description">Add projects on the Inventory page.</p>
      </div>
    </div>

    <!-- ============ KANBAN VIEW (one column per progress state) ============ -->
    <!-- Columns are the working status a PM moves a pursuit through. Sales stage
         is carried on the card (coloured left edge + badge) so both readings are
         available without a second board. -->
    <div *ngIf="viewMode === 'kanban'" class="kanban-view kanban-view--progress">
      <div class="empty-state" *ngIf="visibleKanbanColumns.length === 0">
        <div class="empty-icon"><i class="pi pi-inbox"></i></div>
        <p class="empty-message">No deals match these filters</p>
        <p class="empty-description">Clear a filter, or untick "Hide empty columns" to see every progress state.</p>
      </div>

      <div class="kanban-scroll" *ngIf="visibleKanbanColumns.length > 0">
      <div class="kanban-grid">
        <div class="kanban-col" *ngFor="let col of visibleKanbanColumns"
             [ngClass]="col.cssClass"
             [class.is-empty]="col.projects.length === 0">
          <div class="kanban-col-head">
            <div class="kanban-col-head-top">
              <span class="kanban-col-title">
                <span class="dot" [ngClass]="col.cssClass"></span>{{ col.label }}
              </span>
              <span class="kanban-col-count">{{ col.projects.length }}</span>
            </div>
            <!-- Column subtotal: a count alone doesn't say whether a column holds
                 the pipeline's weight or its long tail. -->
            <span class="kanban-col-sub" *ngIf="col.projects.length > 0 && columnUsdTotal(col) !== null">
              ≈ USD {{ formatMoney(columnUsdTotal(col)!) }}
            </span>
          </div>
          <div class="kanban-col-body">
            <div class="kanban-card kanban-card--rich"
                 *ngFor="let p of col.projects"
                 [ngClass]="stageClass(p.salesStage)"
                 [class.won]="p.salesStage === 'Won'"
                 [class.is-overdue]="p.overdueDays"
                 (click)="openDetails(p)">

              <!-- Row 1: stage badge + RAG dot. The stage is the single most
                   asked-for fact once the column no longer carries it. -->
              <div class="kanban-card-top">
                <span class="k-stage" [ngClass]="stageClass(p.salesStage)">{{ p.salesStage }}</span>
                <span class="k-rag" *ngIf="p.projectStatus"
                      [ngClass]="projectStatusBadgeClass(p.projectStatus)"
                      [pTooltip]="'Health: ' + p.projectStatus" tooltipPosition="top"></span>
              </div>

              <!-- Row 2: the name, given room to breathe as the card's headline. -->
              <h4 class="kanban-card-title" [pTooltip]="p.name" tooltipPosition="top"
                  [tooltipOptions]="{ showDelay: 600 }">{{ p.name }}</h4>

              <!-- Row 3: client + code on one labelled line. -->
              <div class="kanban-card-meta">
                <span class="k-client" [pTooltip]="p.presalesClientName || 'No client set'" tooltipPosition="top">
                  <i class="pi pi-building"></i>{{ p.presalesClientName || 'No client set' }}
                </span>
                <span class="k-code" *ngIf="p.projectCode">{{ p.projectCode }}</span>
              </div>

              <!-- Row 4: value and win probability, the two numbers that rank a deal. -->
              <div class="kanban-card-value">
                <span class="k-money">
                  <span class="cur">{{ p.currency }}</span>{{ formatMoneyCompact(p.revenueTarget) }}
                </span>
                <span class="k-win" [class.k-win--high]="p.winningPercentage >= 70"
                      [pTooltip]="'Winning probability'" tooltipPosition="top">
                  <span class="k-win-bar"><span class="k-win-fill"
                        [style.width.%]="p.winningPercentage || 0"></span></span>
                  {{ p.winningPercentage || 0 }}%
                </span>
              </div>

              <!-- Comments preview, clamped to two lines. Full text on hover and
                   in the details modal — same treatment as the grid card. -->
              <div class="kanban-card-comments" *ngIf="p.comments"
                   [pTooltip]="p.comments" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">
                {{ p.comments }}
              </div>

              <!-- Foot: who owns it, and when it lands. -->
              <div class="kanban-card-foot">
                <span class="k-owner" [pTooltip]="'PM: ' + (p.managerName || 'Unassigned')
                        + (p.accountManagerName ? ' · Sales: ' + p.accountManagerName : '')"
                      tooltipPosition="top">
                  <span class="k-avatar" [style.--k-hue]="avatarHue(p.managerName)">{{ initials(p.managerName) }}</span>
                  <span class="k-owner-name">{{ p.managerName || 'Unassigned' }}</span>
                </span>
                <span class="k-close k-overdue" *ngIf="p.overdueDays">
                  <i class="pi pi-exclamation-circle"></i>{{ p.overdueDays }}d over
                </span>
                <span class="k-close" *ngIf="!p.overdueDays && p.expectedCloseDate"
                      [class.k-close--soon]="isClosingSoon(p.expectedCloseDate)"
                      [pTooltip]="'Expected close: ' + formatDate(p.expectedCloseDate)" tooltipPosition="top">
                  <i class="pi pi-calendar"></i>{{ closeLabel(p.expectedCloseDate) }}
                </span>
              </div>
            </div>
            <div class="kanban-empty" *ngIf="col.projects.length === 0">No deals</div>
          </div>
        </div>
      </div>
      </div>
    </div>

  </div>
</div>


<!-- =========================================================
     Details modal — full-viewport tabbed layout matching the
     delivery Project Details design (98vw / 96vh, tabs act as the header).
     Fixed height on purpose: the tab bar stays put and only the panel below
     scrolls, so switching tabs never moves the dialog or the controls.
     ========================================================= -->
<p-dialog
  [visible]="displayDialog"
  (visibleChange)="displayDialog = $event"
  [modal]="true"
  [style]="{width: '99vw', height: '96vh', maxWidth: 'none'}"
  styleClass="details-modal"
  [dismissableMask]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false">

  <div *ngIf="selectedProject" class="details-modal-container card">
    <div class="tab-nav-container">
      <nav class="tab-nav-header" role="tablist">
        <!-- Only the tabs scroll; the buttons after this div stay pinned. -->
        <div class="tab-nav-tabs">
        <button type="button" role="tab" class="tab-nav-button"
          [class.active]="activeTab === 'overview'" (click)="setTab('overview')">
          Overview
        </button>
        <button type="button" role="tab" class="tab-nav-button"
          [class.active]="activeTab === 'activities'" (click)="setTab('activities')">
          Activities
        </button>
        <button type="button" role="tab" class="tab-nav-button"
          [class.active]="activeTab === 'raid'" (click)="setTab('raid')">
          RAID
        </button>
        <button type="button" role="tab" class="tab-nav-button"
          [class.active]="activeTab === 'team-allocation'" (click)="setTab('team-allocation')">
          Team Allocation
        </button>

        </div><!-- .tab-nav-tabs -->

        <!-- Inline edit controls (Overview tab, Admin/PM only) -->
        <ng-container *ngIf="activeTab === 'overview' && canManage">
          <p-button
            *ngIf="!editMode"
            icon="pi pi-pencil"
            severity="secondary"
            size="small"
            [rounded]="true"
            [text]="true"
            styleClass="tab-nav-icon-btn"
            pTooltip="Edit" tooltipPosition="bottom"
            aria-label="Edit"
            (onClick)="startEdit()" />
          <p-button
            *ngIf="editMode"
            label="Save"
            icon="pi pi-check"
            severity="success"
            size="small"
            styleClass="tab-nav-report-btn"
            [disabled]="saveInFlight"
            (onClick)="saveEdit()" />
          <!-- pi-undo, not pi-times: the Close button at the end of this bar is already an
               X, and two X's side by side doing different things is the main thing that
               made these controls hard to read. -->
          <p-button
            *ngIf="editMode"
            label="Cancel"
            icon="pi pi-undo"
            severity="secondary"
            size="small"
            [text]="true"
            [disabled]="saveInFlight"
            pTooltip="Discard changes" tooltipPosition="bottom"
            (onClick)="cancelEdit()" />
        </ng-container>

        <!-- Jump to the Inventory's own form for this deal: it carries the client, presales
             cost center and sales-stage fields the Overview tab does not. Hidden while
             editing so it cannot be mistaken for a Save. -->
        <p-button
          *ngIf="canManage && !editMode"
          label="Open in Inventory"
          icon="pi pi-external-link"
          severity="secondary"
          size="small"
          [text]="true"
          styleClass="tab-nav-report-btn"
          pTooltip="Edit this deal in Presales Project Inventory" tooltipPosition="bottom"
          (onClick)="openInInventory()" />

        <!-- Promote to Delivery is disabled (promoteEnabled = false) — see the component. -->
        <p-button
          *ngIf="promoteEnabled && isWon() && !isAlreadyPromoted() && !editMode"
          label="Promote to Delivery"
          icon="pi pi-arrow-up-right"
          severity="success"
          size="small"
          styleClass="tab-nav-report-btn"
          (onClick)="openPromoteDialog()" />

        <span class="tab-nav-action-sep" aria-hidden="true"></span>
        <button type="button" class="tab-nav-close" (click)="hideDialog()"
          aria-label="Close" pTooltip="Close dialog" tooltipPosition="bottom">
          <i class="pi pi-times"></i>
        </button>
      </nav>

      <div class="tab-nav-content">

        <!-- ============ OVERVIEW TAB ============ -->
        <div *ngIf="activeTab === 'overview'" class="tab-nav-panel overview-panel"
             [class.is-editing]="editMode">

      <div class="details-card">
        <div class="details-section-label">Presales Fields</div>
        <div class="ro-grid">
          <div class="ro-field">
            <span class="ro-label">Presales Code</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.projectCode">{{ selectedProject.projectCode || '—' }}</span>
          </div>
          <div class="ro-field">
            <span class="ro-label">Project Name</span>
            <span class="ro-value" *ngIf="!editMode">{{ selectedProject.name }}</span>
            <input *ngIf="editMode && editModel" pInputText class="ro-edit-input"
              [(ngModel)]="editModel.name" placeholder="Project name" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Client</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.presalesClientName">{{ selectedProject.presalesClientName || '—' }}</span>
          </div>
          <div class="ro-field">
            <span class="ro-label">Presales Project Manager</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.managerName">{{ selectedProject.managerName || '—' }}</span>
          </div>
          <div class="ro-field">
            <span class="ro-label">Sales Owner</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.accountManagerName">{{ selectedProject.accountManagerName || '—' }}</span>
          </div>
        </div>

        <div class="ro-grid">
          <div class="ro-field">
            <span class="ro-label">Revenue Target</span>
            <span class="ro-value ro-mono ro-money" *ngIf="!editMode">
              <span class="cur">{{ selectedProject.currency }}</span> {{ formatMoney(selectedProject.revenueTarget) }}
            </span>
            <span class="ro-edit-money" *ngIf="editMode && editModel">
              <p-select [options]="currencyOptions" [(ngModel)]="editModel.currency"
                optionLabel="label" optionValue="value" appendTo="body" styleClass="ro-edit-cur" />
              <input pInputText type="number" min="0" class="ro-edit-input"
                [(ngModel)]="editModel.revenueTarget" placeholder="0" />
            </span>
          </div>
          <div class="ro-field">
            <span class="ro-label">Winning %</span>
            <span class="ro-value ro-mono" *ngIf="!editMode">{{ selectedProject.winningPercentage }}%</span>
            <input *ngIf="editMode && editModel" pInputText type="number" min="0" max="100"
              class="ro-edit-input" [(ngModel)]="editModel.winningPercentage" placeholder="0" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Sales Stage</span>
            <span class="ro-value" *ngIf="!editMode">
              <p-tag [value]="selectedProject.salesStage" [severity]="stageSeverity(selectedProject.salesStage)" style="font-size: 0.7rem;" />
            </span>
            <p-select *ngIf="editMode && editModel" [options]="stageOptions" [(ngModel)]="editModel.salesStage"
              optionLabel="label" optionValue="value" appendTo="body" styleClass="ro-edit-select" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Progress</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.progress" *ngIf="!editMode">
              <p-tag *ngIf="selectedProject.progress" [value]="progressLabel(selectedProject.progress)"
                [severity]="progressSeverity(selectedProject.progress)" style="font-size: 0.7rem;" />
              <span *ngIf="!selectedProject.progress">—</span>
            </span>
            <p-select *ngIf="editMode && editModel" [options]="progressOptions" [(ngModel)]="editModel.progress"
              optionLabel="label" optionValue="value" appendTo="body" styleClass="ro-edit-select"
              placeholder="Not set" [showClear]="true" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Project Status</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.projectStatus" *ngIf="!editMode">
              <p-tag *ngIf="selectedProject.projectStatus" [value]="selectedProject.projectStatus"
                [severity]="projectStatusSeverity(selectedProject.projectStatus)" style="font-size: 0.7rem;" />
              <span *ngIf="!selectedProject.projectStatus">—</span>
            </span>
            <p-select *ngIf="editMode && editModel" [options]="projectStatusOptions" [(ngModel)]="editModel.projectStatus"
              optionLabel="label" optionValue="value" appendTo="body" styleClass="ro-edit-select"
              placeholder="Not set" [showClear]="true" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Expected Close</span>
            <span class="ro-value ro-mono" [class.ro-value--empty]="!selectedProject.expectedCloseDate" *ngIf="!editMode">{{ formatDate(selectedProject.expectedCloseDate) }}</span>
            <input *ngIf="editMode && editModel" pInputText type="date"
              class="ro-edit-input" [(ngModel)]="editModel.expectedCloseDate" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Actual Close</span>
            <span class="ro-value ro-mono" [class.ro-value--empty]="!selectedProject.actualCloseDate">{{ formatDate(selectedProject.actualCloseDate) }}</span>
          </div>
        </div>
      </div>

      <!-- Effort Utilization — Planned is editable; Actual comes from timesheet hours logged
           against this pursuit (available at every sales stage), Remaining is derived. -->
      <div class="details-card">
        <div class="details-section-label">Effort Utilization</div>
        <div class="ro-grid">
          <div class="ro-field">
            <span class="ro-label">Planned Estimate (Days)</span>
            <span class="ro-value ro-mono" [class.ro-value--empty]="selectedProject.plannedEstimateDays == null" *ngIf="!editMode">
              {{ selectedProject.plannedEstimateDays ?? '—' }}
            </span>
            <input *ngIf="editMode && editModel" pInputText type="number" min="0" step="0.01"
              class="ro-edit-input" [(ngModel)]="editModel.plannedEstimateDays"
              placeholder="Enter planned estimate in days…" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Actual Effort (Days)</span>
            <span class="ro-value ro-mono">{{ getActualEffortDisplay() }}</span>
          </div>
          <div class="ro-field">
            <span class="ro-label">Remaining Effort (Days)</span>
            <span class="ro-value ro-mono">{{ getRemainingEffort() }}</span>
          </div>
        </div>
      </div>

      <div class="details-card">
        <div class="details-section-label">System Fields</div>
        <div class="ro-grid">
          <div class="ro-field">
            <span class="ro-label">Service Group</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.serviceGroupName" *ngIf="!editMode">{{ selectedProject.serviceGroupName || '—' }}</span>
            <p-select *ngIf="editMode && editModel" [options]="editServiceGroupOptions" [(ngModel)]="editModel.serviceGroupId"
              optionLabel="name" optionValue="id" [showClear]="true" placeholder="Select service group"
              appendTo="body" styleClass="ro-edit-select" [filter]="true" filterPlaceholder="Search…" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Cost Center</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.costCenterName" *ngIf="!editMode">{{ selectedProject.costCenterName || '—' }}</span>
            <p-select *ngIf="editMode && editModel" [options]="costCenterOptions" [(ngModel)]="editModel.costCenterId"
              optionLabel="name" optionValue="id" [showClear]="true" placeholder="Select cost center"
              appendTo="body" styleClass="ro-edit-select" [filter]="true" filterPlaceholder="Search…" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Start Date</span>
            <span class="ro-value ro-mono" [class.ro-value--empty]="!selectedProject.startDate" *ngIf="!editMode">{{ formatDate(selectedProject.startDate) }}</span>
            <input *ngIf="editMode && editModel" pInputText type="date"
              class="ro-edit-input" [(ngModel)]="editModel.startDate" />
          </div>
          <div class="ro-field">
            <span class="ro-label">End Date</span>
            <span class="ro-value ro-mono" *ngIf="!editMode">{{ formatDate(selectedProject.endDate) }}</span>
            <input *ngIf="editMode && editModel" pInputText type="date"
              class="ro-edit-input" [(ngModel)]="editModel.endDate" />
          </div>
          <div class="ro-field">
            <span class="ro-label">Lead Source</span>
            <span class="ro-value" [class.ro-value--empty]="!selectedProject.leadSource" *ngIf="!editMode">{{ selectedProject.leadSource || '—' }}</span>
            <p-select *ngIf="editMode && editModel" [options]="leadSourceOptions" [(ngModel)]="editModel.leadSource"
              optionLabel="label" optionValue="value" [showClear]="true" placeholder="Select lead source"
              appendTo="body" styleClass="ro-edit-select" />
          </div>
        </div>
      </div>

      <!-- Comments & Notes — one free-text box. Description and Scope Summary were
           retired in favour of a single Comments field, which is also shown on the cards. -->
      <div class="details-card"
           *ngIf="editMode || selectedProject.comments || selectedProject.competitor || selectedProject.lostReason">
        <div class="details-section-label">Comments &amp; Notes</div>
        <div class="ro-textareas">

          <div class="ro-textarea" *ngIf="editMode || selectedProject.comments">
            <span class="ro-label">Comments</span>
            <div class="ro-block" *ngIf="!editMode">{{ selectedProject.comments || '—' }}</div>
            <!-- Resizable, so a long note can be dragged taller when needed. -->
            <textarea *ngIf="editMode && editModel" pInputText class="ro-edit-textarea" rows="3"
              [(ngModel)]="editModel.comments" placeholder="Running commentary / notes on this deal"></textarea>
          </div>

          <div class="ro-textarea" *ngIf="selectedProject.competitor && !editMode">
            <span class="ro-label">Competitor</span>
            <div class="ro-block">{{ selectedProject.competitor }}</div>
          </div>
          <div class="ro-textarea" *ngIf="selectedProject.lostReason && !editMode">
            <span class="ro-label">Lost Reason</span>
            <div class="ro-block">{{ selectedProject.lostReason }}</div>
          </div>
        </div>
      </div>

      <!-- Action callout hidden while promoteEnabled is false. The "already promoted" callout
           below is display-only and stays visible. -->
      <div class="promote-callout" *ngIf="promoteEnabled && isWon() && !isAlreadyPromoted()">
        <div class="pc-msg">
          <strong>✓ Deal Won.</strong>&nbsp;Ready to move this into active delivery — creates a Client + Project in the main system.
        </div>
        <p-button label="Promote to Delivery" icon="pi pi-arrow-up-right" severity="success" (onClick)="openPromoteDialog()" />
      </div>

    </div>

        <!-- ============ TAB CONTENTS ============ -->
        <!-- Each tab component is @Input()-bound to selectedProject.id; components
             self-load on ngOnInit / ngOnChanges. Only the active tab is mounted
             so tabs the user never opens don't fire HTTP calls. -->
        <div *ngIf="activeTab !== 'overview'" class="tab-nav-panel tab-nav-panel--fill">
          <ng-container [ngSwitch]="activeTab">
            <app-presales-activity
              *ngSwitchCase="'activities'"
              [presalesProjectId]="selectedProject.id" />

            <app-presales-raid
              *ngSwitchCase="'raid'"
              [presalesProjectId]="selectedProject.id" />

            <!-- Allocations are stored against the TWIN Projects row, so this takes
                 promotedToProjectId (set from pursuit creation), not the presales id. -->
            <app-team-allocation-month
              *ngSwitchCase="'team-allocation'"
              [projectId]="selectedProject.promotedToProjectId || ''"
              [projectName]="selectedProject.name" />
          </ng-container>
        </div>

      </div><!-- .tab-nav-content -->
    </div><!-- .tab-nav-container -->
  </div><!-- .details-modal-container -->
</p-dialog>


<!-- =========================================================
     PROMOTE-TO-DELIVERY wizard — same compact 3-step design as
     the Inventory page for consistency.
     Backs onto POST /api/PresalesProject/{id}/promote (transactional).

     DISABLED: gated on promoteEnabled, which is false. Kept rather than deleted.
     ========================================================= -->
<p-dialog
  *ngIf="promoteEnabled"
  [visible]="displayPromoteDialog"
  (visibleChange)="displayPromoteDialog = $event"
  header="Promote to Delivery"
  [modal]="true"
  styleClass="dialog-sm promote-wizard-dialog"
  [dismissableMask]="!promoteInFlight"
  [closable]="!promoteInFlight">

  <div class="promote-wiz" *ngIf="selectedProject">
    <!-- Compact deal banner -->
    <div class="promote-wiz-deal">
      <i class="pi pi-send"></i>
      <div class="promote-wiz-deal-info">
        <span class="promote-wiz-deal-title">{{ selectedProject.name }}</span>
        <span class="promote-wiz-deal-sub" *ngIf="selectedProject.presalesClientName">{{ selectedProject.presalesClientName }}</span>
        <span class="promote-wiz-deal-sub text-warn" *ngIf="!selectedProject.presalesClientName">No presales client linked</span>
      </div>
    </div>

    <!-- Step indicator -->
    <ol class="promote-wiz-steps">
      <ng-container *ngFor="let s of promoteSteps; let last = last">
        <li class="promote-wiz-step"
            [class.active]="promoteStep === s.n"
            [class.done]="promoteStep > s.n">
          <span class="promote-wiz-step-dot">
            <i class="pi pi-check" *ngIf="promoteStep > s.n"></i>
            <span *ngIf="promoteStep <= s.n">{{ s.n }}</span>
          </span>
          <span class="promote-wiz-step-label">{{ s.title }}</span>
        </li>
        <li class="promote-wiz-connector" *ngIf="!last" [class.done]="promoteStep > s.n"></li>
      </ng-container>
    </ol>

    <div class="promote-wiz-body">
      <!-- STEP 1: Client -->
      <div *ngIf="promoteStep === 1" class="promote-wiz-panel">
        <p class="promote-wiz-hint">
          Only the client <strong>Name</strong> and <strong>Description</strong> move — no other presales fields.
        </p>

        <div class="promote-wiz-choices">
          <label class="promote-wiz-choice"
                 [class.selected]="promoteMode === 'create'"
                 [class.disabled]="!selectedProject.presalesClientName">
            <input type="radio" name="promoteMode" [(ngModel)]="promoteMode" value="create"
                   [disabled]="!selectedProject.presalesClientName" />
            <div>
              <div class="promote-wiz-choice-title"><i class="pi pi-plus-circle"></i> Create new Client</div>
              <div class="promote-wiz-choice-desc">
                From "<strong>{{ selectedProject.presalesClientName || '—' }}</strong>"
              </div>
            </div>
          </label>

          <label class="promote-wiz-choice" [class.selected]="promoteMode === 'link'">
            <input type="radio" name="promoteMode" [(ngModel)]="promoteMode" value="link" />
            <div>
              <div class="promote-wiz-choice-title"><i class="pi pi-link"></i> Link existing</div>
              <div class="promote-wiz-choice-desc">Pick from main Clients</div>
            </div>
          </label>
        </div>

        <div class="promote-wiz-existing" *ngIf="promoteMode === 'link'">
          <label>Existing Client <span class="required-star">*</span></label>
          <p-select [(ngModel)]="promoteExistingClientId"
            [options]="mainClients" optionLabel="name" optionValue="id"
            placeholder="Select from main Clients"
            [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>

      <!-- STEP 2: Delivery project details -->
      <div *ngIf="promoteStep === 2" class="promote-wiz-panel">
        <p class="promote-wiz-hint">Both are optional — leave blank to reuse the presales name.</p>

        <div class="field">
          <label>Delivery Project Name</label>
          <input pInputText [(ngModel)]="promoteProjectNameOverride"
            [placeholder]="selectedProject.name" />
        </div>
        <div class="field">
          <label>Delivery Project Code</label>
          <input pInputText [(ngModel)]="promoteProjectCodeOverride"
            placeholder="e.g., BID-03454" />
          <small class="field-hint">Different from the presales code ({{ selectedProject.projectCode || '—' }}).</small>
        </div>
      </div>

      <!-- STEP 3: Review -->
      <div *ngIf="promoteStep === 3" class="promote-wiz-panel">
        <p class="promote-wiz-hint">Here's what will happen when you click Promote.</p>

        <ul class="promote-wiz-review">
          <li>
            <i class="pi pi-check"></i>
            <span *ngIf="promoteMode === 'create'">
              New Client <strong>{{ selectedProject.presalesClientName }}</strong> in main Clients
            </span>
            <span *ngIf="promoteMode === 'link'">
              Linked to <strong>{{ getMainClientName(promoteExistingClientId) }}</strong>
            </span>
          </li>
          <li>
            <i class="pi pi-check"></i>
            New delivery Project <strong>{{ promoteProjectNameOverride.trim() || selectedProject.name }}</strong>
            <span *ngIf="promoteProjectCodeOverride.trim()"> ({{ promoteProjectCodeOverride.trim() }})</span>
          </li>
          <li>
            <i class="pi pi-check"></i>
            This presales row marked <strong>Promoted</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="promote-wiz-footer">
      <p-button *ngIf="promoteStep > 1"
        label="Back" icon="pi pi-arrow-left"
        (onClick)="backPromoteStep()"
        severity="secondary" [outlined]="true" [disabled]="promoteInFlight" />
      <p-button *ngIf="promoteStep === 1 || promoteStep === 2"
        label="Cancel" icon="pi pi-times"
        (onClick)="closePromoteDialog()"
        severity="secondary" [text]="true" [disabled]="promoteInFlight"
        styleClass="promote-wiz-cancel" />
      <span class="promote-wiz-footer-spacer"></span>
      <p-button *ngIf="promoteStep < 3"
        label="Next" icon="pi pi-arrow-right" iconPos="right"
        (onClick)="nextPromoteStep()"
        severity="primary" [disabled]="!canGoNextPromoteStep()" />
      <p-button *ngIf="promoteStep === 3"
        label="Promote" icon="pi pi-send" severity="success"
        [loading]="promoteInFlight"
        [disabled]="!canConfirmPromote()"
        (onClick)="confirmPromote()" />
    </div>
  </ng-template>
</p-dialog>
